<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('import') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
            <router-link v-if="!isAvailable" to="/income" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('save')}}</router-link>
            <button v-if="!isAvailable" type="button" class="btn btn-outline-primary btn-sm no-bor" @click="isAvailable=true"><i class="fa fa-times"></i> {{$t('reset')}}</button>
        </div>
        <div class="x_body">
            <div class="card n_card">
                <div class="card-body" style="padding: 0;">
                    <div v-if="isAvailable" class="uploader">
                        <input type="file" style="display: none;" ref="file" @change="fileChange">
                        <div class="drap-file" @click="$refs.file.click()">
                            Excel importer
                        </div>
                    </div>
                    <div v-else>
                        <table class="table table-bordered table-sm">
                            <thead>
                                <tr>
                                    <th>{{$t('no')}}</th>
                                    <th>{{$t('account_no')}}</th>
                                    <th>{{$t('account_name')}}</th>
                                    <th>{{$t('type')}}</th>
                                    <th>{{$t('balance')}}</th>
                                    <th>{{$t('description')}}</th>
                                    <th>{{$t('tax_line')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret, index) in records" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{ret.FieldE}}</td>
                                    <td>{{ret.FieldA}}</td>
                                    <td>{{ret.FieldB}}</td>
                                    <td>{{ret.FieldC}}</td>
                                    <td>{{ret.FieldD}}</td>
                                    <td>{{ret.FieldF}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            isAvailable: true,
            records: []
        }
    },
    methods: {
        fileChange(){
            var formData = new FormData();
            formData.append('File', this.$refs.file.files[0]);
            this.$api().post('income/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                this.records = res.data;
                this.isAvailable = false;
            });
        }
    }
}
</script>
<style scoped>
    .uploader{
        padding: 1px;
        margin: 10px;
    }
    .uploader .drap-file{
        font-size: 24px;
        border: 1px dashed #0856ab; text-align:center;
        border-radius: 5px; padding: 50px; cursor:pointer;
        color: #0856ab;
    }
    .uploader .drap-file:hover{
        background: #f2f2f2;;
    }
</style>